import React from "react";
import SbEditable from "storyblok-react";
import InputSizeMap from "./InputSizeMap";

const TextInput = ({ blok, register, errors }) => {
    return(
        <SbEditable content={blok}>
            <div className={`bg-white ${InputSizeMap(blok.size)} mb-4`}>
                {!blok.hide_label && <label for={blok.name} className="block font-bold text-sm mb-1">{blok.label}{blok.required && <span className="text-teal">*</span>}</label>}
                <input {...register(blok.name, { required: blok.required })} className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200" type="text" name={blok.name} id={blok.name} placeholder={blok.placeholder} />
                {errors[blok.name] && <span className="italic text-sm text-red-500">This field is required</span>}
            </div>
        </SbEditable>
    )
}

export default TextInput